import { Link } from 'react-router-dom';
import { motion, useReducedMotion } from 'motion/react';
import { SUCCESS_STORIES } from '../../data/siteContent';

function QuoteCard({ story }) {
  return (
    <blockquote className="w-[320px] shrink-0 rounded-3xl border border-[#e4e0d6] bg-white p-5">
      <p className="line-clamp-4 text-[15px] leading-relaxed text-[#0f2137]">“{story.quote}”</p>
      <footer className="mt-4 text-sm text-[#5b6570]">
        <strong className="font-semibold text-[#1b365d]">{story.name}</strong>
        <span> · {story.focus}</span>
      </footer>
    </blockquote>
  );
}

export default function QuoteMarquee() {
  const reduce = useReducedMotion();
  const loop = [...SUCCESS_STORIES, ...SUCCESS_STORIES];

  return (
    <section className="overflow-hidden py-16" aria-label="Student stories">
      <div className="mx-auto mb-8 w-[min(100%-40px,1180px)]">
        <p className="text-xs font-semibold uppercase tracking-[0.16em] text-[#c5a046]">Proof</p>
        <h2
          className="mt-2 text-3xl text-[#0f2137] md:text-5xl"
          style={{ fontFamily: 'Outfit, sans-serif', letterSpacing: '-0.03em' }}
        >
          Students who crossed the bridge
        </h2>
      </div>
      {reduce ? (
        <div className="mx-auto grid w-[min(100%-40px,1180px)] gap-4 md:grid-cols-2">
          {SUCCESS_STORIES.map((story) => (
            <QuoteCard key={story.name} story={story} />
          ))}
        </div>
      ) : (
        <motion.div
          className="flex w-max gap-4 px-5"
          animate={{ x: ['0%', '-50%'] }}
          transition={{ duration: 46, repeat: Infinity, ease: 'linear' }}
        >
          {loop.map((story, index) => (
            <QuoteCard key={`${story.name}-${index}`} story={story} />
          ))}
        </motion.div>
      )}
      <div className="mt-8 text-center">
        <Link to="/success-stories" className="mk-btn mk-btn-ghost">
          Read success stories
        </Link>
      </div>
    </section>
  );
}
